import React from 'react';
import $ from 'jquery';
import Iconfont from './iconfont';
let defaultIconFontMode = 'svg';
const Icon = (props) => {
    var _a;
    const { icon = '', className = '', style = {}, iconMode = defaultIconFontMode, onClick } = props;
    if (!icon)
        return null;
    if (React.isValidElement(icon)) {
        // @ts-ignore
        const { style: orignStyle, originClassnName = '' } = icon.props;
        return React.cloneElement(icon, {
            style: Object.assign(Object.assign({}, orignStyle), style),
            className: `${originClassnName} ${className}`,
            onClick
        });
    }
    ;
    // 判断是否是svg
    const svgDomString = (_a = /(<svg([^>])*>([\d\D])*<\/svg>)/i.exec(icon)) === null || _a === void 0 ? void 0 : _a[0];
    const svgDom = svgDomString
        ? $(svgDomString).css({ width: '100%', height: '100%' })[0].outerHTML
        : null;
    const isImg = !svgDom &&
        (icon.startsWith('http') ||
            icon.startsWith('/') ||
            icon.includes(';base64,'));
    return svgDom ? (React.createElement("span", { dangerouslySetInnerHTML: { __html: svgDom }, style: Object.assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), className: className, onClick: onClick })) : isImg ? (React.createElement("span", { style: Object.assign({ display: 'inline-flex', alignItems: 'center', justifyContent: 'center' }, style), className: className, onClick: onClick },
        React.createElement("img", { src: icon, style: { width: '100%', height: '100%' } }))) : (React.createElement(Iconfont, { style: Object.assign(Object.assign(Object.assign({ lineHeight: 1 }, style), { width: 'initial', height: 'initial' }), ((style && style.height) || style.width
            ? { fontSize: style.height || style.width }
            : {})), className: className, type: icon, iconMode: iconMode, onClick: onClick }));
};
Icon.loadIconfont = (url) => {
    Iconfont.loadIconfont(url);
};
Icon.setDefaultIconfontMode = (iconMode) => {
    defaultIconFontMode = iconMode;
};
export default Icon;
//# sourceMappingURL=index.js.map